import { CloseOutlined } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import Button from "@mui/material/Button";
import React from "react";
import {
  PasswordInput,
  ReferenceInput,
  SelectInput,
  useRefresh,
} from "react-admin";
import useNotify from "../../unit/useNotify";
import Refill from "./Refill";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomDialogTitle from "../../unit/CustomDialogTitle";

const RefillsAdd = (props: any) => {
  const refresh = useRefresh();
  const id = 99999;
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    refresh();
  };
  const auth = localStorage.getItem("authrole");

  if (auth != "admin" && auth != "bankadmin") {
    return null;
  }
  return (
    <>
      <Button
        onClick={handleOpen}
        id="dialog-banker-add"
        variant="text"
        color="primary"
        size="small"
        sx={{
          width: "120px",
          minWidth: "120px",
          color: "primary.main",
          "&.MuiButton-sizeSmall": {
            lineHeight: 1.5,
            fontSize: "0.875rem",
          },
        }}
      >
        <AddIcon sx={{ fontSize: "1.25rem" }} /> Refill
      </Button>
      <Dialog
        id="dialog-banker-add"
        className="bankers_add_dialog"
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="md"
      >
        <DialogTitle
          sx={{
            borderBottom: "1px solid #e5e5e5",
            mb: 2,
          }}
        >
          <CustomDialogTitle title={`Refill Dwolla Balance`} />
          <IconButton
            style={{ position: "absolute", right: "10px", top: "10px" }}
            onClick={handleClose}
          >
            <CloseOutlined />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ padding: "10px" }}>
          <Refill cb={handleClose} />
        </DialogContent>
        {/* <DialogActions></DialogActions> */}
      </Dialog>
    </>
  );
};

export default RefillsAdd;
